module.exports = __webpack_public_path__ + "img/ok-icon.2766bf40.svg";